import { client } from "api";

export type AddExternalUserRequest = { userId: string; orderId: string };
export type AddExternalUserResponse = string;

export const addExternalUser = (params: AddExternalUserRequest) =>
  client.post<AddExternalUserResponse>(`/order/assign`, params).then((res) => res.data);
